class AccordionItem extends HTMLElement {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.trigger = this.querySelector('[data-accordion-trigger]');
    if (!this.trigger) return;

    this.restoreState();
    this.trigger.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    if (this.trigger) {
      this.trigger.removeEventListener('click', this.handleClick);
    }
  }

  getStorageKey() {
    const id = this.dataset.accordionId;
    return id ? `accordion-item:${id}` : null;
  }

  restoreState() {
    const key = this.getStorageKey();
    if (!key) return;

    let storedState;
    try {
      storedState = sessionStorage.getItem(key);
    } catch (error) {
      return;
    }
    if (storedState === null) return;

    const isOpen = storedState === 'true';
    this.classList.toggle('opened', isOpen);
    this.trigger.setAttribute('aria-expanded', isOpen);
  }

  handleClick() {
    const isOpen = this.classList.toggle('opened');
    this.trigger.setAttribute('aria-expanded', isOpen);

    const key = this.getStorageKey();
    if (!key) return;

    try {
      sessionStorage.setItem(key, isOpen);
    } catch (error) {
      // Ignore storage errors (e.g. disabled storage); state just won't persist.
    }
  }
}

if (!customElements.get('accordion-item')) {
  customElements.define('accordion-item', AccordionItem);
}
